import { render } from "./PosCobro.vue?vue&type=template&id=9df0ef4a&scoped=true"
import script from "./PosCobro.vue?vue&type=script&lang=js"
export * from "./PosCobro.vue?vue&type=script&lang=js"

import "./PosCobro.vue?vue&type=style&index=0&id=9df0ef4a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9df0ef4a"]])

export default __exports__